@if (authenticationService.showAlert) {
  <app-alert></app-alert>
}
@if (showBanner) {
  <div class="alert alert-dismissible alert-warning d-flex wrong-url-banner" role="alert">
    <span class="material-icons">error</span>
    <button type="button" class="btn-close mt-2" data-bs-dismiss="alert"></button>
    <div>
      <div>The URL you used is no longer valid. You have been redirected to the correct URL.</div>
    </div>
  </div>
}
@if (userExist && initialized) {
  <app-header></app-header>
}
<div class="body">
  @if (userHasNoRights) {
    <div style="color: red;"><i>It seems that you have no registered rights. For any request, please fill this form <a href="https://forms.cloud.microsoft/e/kEUHpJV6kJ" target="_blank">Request for Digital Cockpit Access</a></i></div>
  }
  @if (initialized) {
    <router-outlet></router-outlet>
  }
</div>
